module.exports = __webpack_public_path__ + "logo-5b955141f831b3cd8d10ba0748b90a5e.svg";